import styled from 'styled-components'

export const NoVehicleContainer = styled.section`
  padding: 12px;
  border: 1px solid  #D4D4D6;
  border-radius: 4px;
  background:  #FFF;
  
  button {
    width: 100%;
  }
`

export const ShopTitle = styled.h4`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0 0 8px 0;
`

export const ShopMessage = styled.p`
  color:  #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0 0 8px 0;
`
